
import {
  FETCH_BINBATCH_REQUEST,
  FETCH_BINBATCH_SUCCESS,
  FETCH_BINBATCH_FAILURE,
  FETCH_ORGANIZATION_REQUEST,
  FETCH_ORGANIZATION_SUCCESS,
  FETCH_ORGANIZATION_FAILURE,
  FETCH_SEASON_REQUEST,
  FETCH_SEASON_SUCCESS,
  FETCH_SEASON_FAILURE,
  FETCH_BINMASTER_REQUEST,
  FETCH_BINMASTER_SUCCESS,
  FETCH_BINMASTER_FAILURE,
  FETCH_DRYING_REQUEST,
  FETCH_DRYING_SUCCESS,
  FETCH_DRYING_FAILURE,
  FETCH_DRYINGLINE_FAILURE,
  FETCH_DRYINGLINE_SUCCESS,
  FETCH_DRYINGLINE_REQUEST,
  
} from "./actionTypes";

const initialState = {

  binBatch: {
    data: [],
    loading: false,
    error: null,
  },

  organizations: {
    data: [],
    loading: false,
    error: null,
  },

  season: {
    data: [],
    loading: false,
    error: null,
  },

  binMaster: {
    data: [],
    loading: false,
    error: null,
  },
    dryingLine: {
    data: [],
    loading: false,
    error: null,
  },

  drying: {
    data: [],
    loading: false,
    error: null,
  },
};

const binBatchReducer = (state = initialState, action) => {
  switch (action.type) {
  
    case FETCH_BINBATCH_REQUEST:
      return {
        ...state,
        binBatch: {
          ...state.binBatch,
          loading: true,
          error: null,
        },
      };

    case FETCH_BINBATCH_SUCCESS:
      return {
        ...state,
        binBatch: {
          data: action.payload,
          loading: false,
          error: null,
        },
      };

    case FETCH_BINBATCH_FAILURE:
      return {
        ...state,
        binBatch: {
          ...state.binBatch,
          loading: false,
          error: action.payload,
        },
      };

   
    case FETCH_ORGANIZATION_REQUEST:
      return {
        ...state,
        organizations: {
          ...state.organizations,
          loading: true,
          error: null,
        },
      };

    case FETCH_ORGANIZATION_SUCCESS:
      return {
        ...state,
        organizations: {
          data: action.payload,
          loading: false,
          error: null,
        },
      };

    case FETCH_ORGANIZATION_FAILURE:
      return {
        ...state,
        organizations: {
          ...state.organizations,
          loading: false,
          error: action.payload,
        },
      };

   
    case FETCH_SEASON_REQUEST:
      return {
        ...state,
        season: {
          ...state.season,
          loading: true,
          error: null,
        },
      };

    case FETCH_SEASON_SUCCESS:
      return {
        ...state,
        season: {
          data: action.payload,
          loading: false,
          error: null,
        },
      };

    case FETCH_SEASON_FAILURE:
      return {
        ...state,
        season: {
          ...state.season,
          loading: false,
          error: action.payload,
        },
      };

 
    case FETCH_BINMASTER_REQUEST:
      return {
        ...state,
        binMaster: {
          ...state.binMaster,
          loading: true,
          error: null,
        },
      };

    case FETCH_BINMASTER_SUCCESS:
      return {
        ...state,
        binMaster: {
          data: action.payload,
          loading: false,
          error: null,
        },
      };

    case FETCH_BINMASTER_FAILURE:
      return {
        ...state,
        binMaster: {
          ...state.binMaster,
          loading: false,
          error: action.payload,
        },
      };

   
    case FETCH_DRYING_REQUEST:
      return {
        ...state,
        drying: {
          ...state.drying,
          loading: true,
          error: null,
        },
      };

    case FETCH_DRYING_SUCCESS:
      return {
        ...state,
        drying: {
          data: action.payload,
          loading: false,
          error: null,
        },
      };

    case FETCH_DRYING_FAILURE:
      return {
        ...state,
        drying: {
          ...state.drying,
          loading: false,
          error: action.payload,
        },
      };
        // ==================== DRYING LINE ====================
    case FETCH_DRYINGLINE_REQUEST:
      return {
        ...state,
        dryingLine: {
          ...state.dryingLine,
          loading: true,
          error: null,
        },
      };

    case FETCH_DRYINGLINE_SUCCESS:
      return {
        ...state,
        dryingLine: {
          data: action.payload,
          loading: false,
          error: null,
        },
      };

    case FETCH_DRYINGLINE_FAILURE:
      return {
        ...state,
        dryingLine: {
          ...state.dryingLine,
          loading: false,
          error: action.payload,
        },
      };

    default:
      return state;
  }
};

export default binBatchReducer;